import styled from 'styled-components';

const StyledDriverCard = styled.div`
  width: 350px;
  position: absolute;
  top: 8px;
  left: 8px;
`;

const StyledVehicleWarning = styled.div`
  padding: 8px;
  background: var(--accent100);
  color: var(--accent900);
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledPositionText = styled.div`
  padding: 4px;
  color: var(--grey700);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledAction = styled.button`
  border: 0;
  background: transparent;
  -webkit-appearance: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { StyledDriverCard, StyledPositionText, StyledAction, StyledVehicleWarning };
